import { makeRequest2 } from "../../../../utils/makeRequest";

const missingCreditsUrl = (facilityId) =>
  `/api/app/payment_management/missing_utility_credits/${facilityId}`;

/**
 * Power/water credits that have no matching M-Pesa/bank transaction (e.g. a
 * manually uploaded NCBA payment). channel is "digital" or "bank".
 * Never throws: finance keeps working if this lookup fails.
 */
export const fetchMissingUtilityCredits = async ({ facilityId, channel, startDate, endDate, search }) => {
  try {
    const params = new URLSearchParams({ channel });
    if (startDate) params.append("startDate", startDate.toISOString().split("T")[0]);
    if (endDate) params.append("endDate", endDate.toISOString().split("T")[0]);
    if (search && search.trim()) params.append("search", search.trim());

    const response = await makeRequest2(`${missingCreditsUrl(facilityId)}?${params}`, "GET");
    const rows = response?.success ? response.data?.data : [];
    return Array.isArray(rows) ? rows : [];
  } catch (err) {
    console.error("Error fetching utility credits:", err);
    return [];
  }
};

/**
 * Put credits into the page of transactions they belong to, newest first.
 * The transactions are paged by the server, so a credit is shown on the page
 * whose date range covers it (the first page also takes anything newer, the last
 * page anything older). A credit is never shown on two pages.
 */
export const mergeMissingCredits = (pageRows, credits, pagination, key = "createdAt") => {
  if (!credits.length) return pageRows;

  const time = (row) => new Date(row[key]).getTime();
  const isFirst = !pagination || pagination.currentPage <= 1;
  const isLast = !pagination || !pagination.hasNextPage;

  let newest = -Infinity;
  let oldest = Infinity;
  pageRows.forEach((row) => {
    const t = time(row);
    if (t > newest) newest = t;
    if (t < oldest) oldest = t;
  });

  const belongs = (credit) => {
    if (!pageRows.length) return isFirst; // nothing on this page: show them once, on page 1
    const t = time(credit);
    if (t > newest) return isFirst;
    if (t < oldest) return isLast;
    return true;
  };

  return [...pageRows, ...credits.filter(belongs)].sort((a, b) => time(b) - time(a));
};

// Small label shown next to a receipt / reference for rows that come from a credit
export const creditSourceLabel = (row) => (row?.fromCredit ? row.source || "Utility credit" : null);
